export enum ExperimentGroup {
    A = 'a',
    B = 'b',
    C = 'c',
    D = 'd',
    E = 'e',
    F = 'f',
    G = 'g',
    H = 'h'
}

export enum ExperimentType {
    MlMatching = 'FF001',
    GTM3001 = '3001',
    FF003 = 'FF003',
    FF004 = 'FF004', // Streaming: Cloudflare vs Calls API (B) vs IVS (C)
    FF006 = 'FF006',
    FF008 = 'FF008',  // Streaming: Cloudflare vs IVS
    IF4477 = 'IF4477',
    FF007 = 'FF007', // Story. ML operators recommendation for user
    FF009 = 'FF009', // Transfer to VAST different landing pages
    FF011 = 'FF011', // Payment. Disabled cryptocurrency payment icon
    FF012 = 'FF012', // Signup. Select gender after signup (only one button on the main page)
    FF014 = 'FF014', // New Offer Screen: Default design vs New design vs New design with coins
    FF015 = 'FF015', // Payment. Showing the last used payment method on the first place on the join page
}

export enum JoinCondition {
    Visit = 'visit',
    Own = 'own',
}
